<template>
    <el-form ref="pfForm" :model="pfForm">
        <div class="xlTd" style="width: 1100px;">
            <tr height="20" style='height:30.00pt;'></tr>

            <tr height="26.67">
                <td class="xl65" height="26.67" width="425" colspan="3"
                    style='height:20.00pt;width:318.75pt;border-right:none;border-bottom:none;' x:str>
                    学生姓名:{{stuName}}</td>
                <td class="xl66" width="991" style='width:743.25pt;' x:str>班级名称:{{tableData.class.comboName}}</td>
            </tr>
            <tr height="26.67">
                <td class="xl67" height="53.33" rowspan="2"
                    style='height:40.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;min-width: 40px;'
                    x:str>序号
                </td>

                <td class="xl671" height="53.33" rowspan="2"
                    style='height:40.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;min-width: 120px;'
                    x:str>评价项目
                </td>

                <td class="xl68" colspan="2" rowspan="2"
                    style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>评价标准</td>
                <td class="xl69" :colspan="tableData.teaData.length" x:str>教师姓名(课程)</td>

                <td class="xl77"></td>
            </tr>
            <tr height="26.67">

                <template v-for="(item,index) in tableData.teaData">
                    <td class="xl70" x:str>{{item.teaName}}
                        <font class="font0"><br /></font>
                        <font class="font0">({{parseCourseName(item.courseName)}})</font>
                    </td>
                </template>
                <td class="xl77"></td>
            </tr>

            <template v-for="(item,row) in tableData.pjxData">
                <tr height="53.33" style='height:40.00pt;mso-height-source:userset;mso-height-alt:800;'>
                    <td class="xl71" height="53.33" style='height:40.00pt;' x:num>{{item.xh}}</td>

                    <td class="xl711" height="53.33" style='height:40.00pt;' x:num>{{item.pjxmc}}</br>({{item.qz}})
                    </td>

                    <td class="xl72" colspan="2"
                        style='border-right:.5pt solid windowtext;border-bottom:1.0pt solid windowtext;' x:str>
                        {{item.pjxnr}}
                    </td>
                    <template v-for="(itemB,column) in tableData.teaData">
                        <td class="xl73" x:str>
                            <el-form-item :prop="'pfArr['+row+']['+column+']'"
                                :rules="[{required: true, message: ' '}]">
                                <el-input-number v-model="pfForm.pfArr[row][column]" size="mini" :min="0"
                                    :max="qzArr[row][column]"
                                    @input="changePf($event,item.bh,tableData.teaData[column].teaCode,row,column,tableData.teaData[column].courseName,tableData.teaData[column].courseCode)">
                                </el-input-number>
                            </el-form-item>
                        </td>
                    </template>
                    <td class="xl77"></td>
                </tr>
            </template>

            <tr height="20" style='height:30.00pt;'>
            </tr>
        </div>
    </el-form>
</template>

<script>
    import {
        confirmMsg,
        showNotify
    } from "utils/message";

    export default {
        props: ['stuName', 'stuCode', 'type', 'semesterCode'],
        data() {
            return {
                tableData: {
                    class: [],
                    pjxData: [],
                    teaData: []
                },
                //评分
                pfForm: {
                    pfArr: [],
                },
                //权重
                qzArr: [],
                //提交
                subArr: [],
                //存储得分
                dfArr: [],
                loadingMask:null
            };
        },
        mounted() {
            this.queryTableData();
        },
        methods: {
            parseCourseName(str){
                let split = str.split("、");
                let set = new Set();
                split.forEach(item=>{
                    set.add(item)
                })
                str = "";
                set.forEach(item=>{
                    str += item + "、"
                })
                return str.substring(0, str.length - 1);
            },
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            /**关闭loading**/
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
            //提交问卷
            submit() {
                this.$refs["pfForm"].validate((valid) => {
                    if (valid) {

                        confirmMsg('提交后无法修改,是否确定提交?').then(() => {
                            this.showLoadingMask('提交中，请稍候...')
                            let sub = [];
                            for (var i = 0; i < this.dfArr.length; i++) {
                                for (var j = 0; j < this.dfArr[i].length; j++) {
                                    sub.push(this.dfArr[i][j])
                                }
                            }

                            let formData = new FormData();
                            formData.append('type', this.type);
                            formData.append('semesterCode', this.semesterCode)
                            formData.append('cjr', this.stuCode)
                            formData.append('classCode', this.tableData.class.comboValue)
                            formData.append('list', sub)

                            this.$api.evaluateManage.questionnaireServer.subStuEvaluate({
                                    data: formData
                                })
                                .then((res) => {
                                    let state = res.data.data;
                                    switch (state) {
                                        case 'Success':
                                            // showNotify('成功', '提交成功', 'success', 1500);
                                            location.reload();
                                            break;
                                        default:
                                            this.closeLoadingMask()
                                            showNotify('错误', '提交失败', 'error', 3000);
                                            break;
                                    }
                                }).catch((err) => {
                                this.closeLoadingMask()
                                    console.log(err);
                                });
                        });
                    } else {
                        return false;
                    }
                });

            },
            //修改评分
            changePf(event, pjxBh, teaCode, row, column, courseName, courseCode) {
                this.dfArr[row][column] = pjxBh + "@" + teaCode + "@" + event + "@" + courseName + "@" + courseCode + "@" + this.qzArr[row][column];
            },
            queryTableData() {
                //评价项数据
                this.$api.evaluateManage.questionnaireServer.pjxData({
                        data: this.type
                    })
                    .then((res) => {
                        this.tableData.pjxData = res.data.data

                        //教师信息
                        let formData = new FormData();
                        formData.append('stuCode', this.stuCode);
                        formData.append('semesterCode', this.semesterCode)
                        this.$api.evaluateManage.questionnaireServer.stuTeaData({
                                data: formData
                            })
                            .then((res) => {
                                this.tableData.teaData = res.data.data

                                var pf = [];
                                var qz = [];
                                var df = [];
                                for (var i = 0; i < this.tableData.pjxData.length; i++) {
                                    pf[i] = [];
                                    qz[i] = [];
                                    df[i] = [];

                                    for (var j = 0; j < this.tableData.teaData.length; j++) {
                                        pf[i][j] = undefined;
                                        df[i][j] = undefined;
                                        qz[i][j] = parseInt(this.tableData.pjxData[i].qz);
                                    }
                                }
                                this.pfForm.pfArr = pf;
                                this.qzArr = qz;
                                this.dfArr = df;

                            }).catch((err) => {
                                console.log(err);
                            });
                    }).catch((err) => {
                        console.log(err);
                    });

                //班级名称
                this.$api.evaluateManage.questionnaireServer.class({
                        data: this.stuCode
                    })
                    .then((res) => {
                        this.tableData.class = res.data.data
                    }).catch((err) => {
                        console.log(err);
                    });
            }
        },
    };
</script>

<style>
    /* 教师教学质量评价（学生） start */
    .font0 {
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: "宋体";
        mso-generic-font-family: auto;
        mso-font-charset: 134;
    }

    .styleStu {
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;
        mso-style-name: "常规";
        mso-style-id: 0;
    }

    .xlTd {
        mso-style-parent: styleStu;
        padding-top: 1px;
        padding-right: 1px;
        padding-left: 1px;
        mso-ignore: padding;
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;

        overflow: auto;
        width: 100%;
    }

    .xl65 {
        mso-style-parent: styleStu;
        text-align: left;
        font-weight: 700;
        mso-font-charset: 134;

        position: sticky;
        left: 0px;
        background-color: #ffffff;
    }

    .xl66 {
        mso-style-parent: styleStu;
        font-weight: 700;
        mso-font-charset: 134;

        position: sticky;
        left: 460px;
        background-color: #ffffff;
    }

    .xl67 {
        mso-style-parent: styleStu;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 0;
        background-color: #ffffff;
    }

    .xl671 {
        mso-style-parent: styleStu;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;


        position: sticky;
        left: 40px;
        background-color: #ffffff;
    }

    .xl68 {
        mso-style-parent: styleStu;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 160px;
        background-color: #ffffff;
    }

    .xl69 {
        mso-style-parent: styleStu;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .xl70 {
        mso-style-parent: styleStu;
        text-align: center;

        /* ------------ */
        /* overflow: hidden; */
        white-space: normal;
        /* width: 10%; */
        /* ------------ */

        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        z-index: 1;
        left: 460px;
        background-color: #ffffff;
    }

    .xl71 {
        mso-style-parent: styleStu;
        text-align: center;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;

        position: sticky;
        left: 0;
        background-color: #ffffff;
        z-index: 99;
    }

    .xl711 {
        mso-style-parent: styleStu;
        text-align: center;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;

        position: sticky;
        left: 40px;
        background-color: #ffffff;
        z-index: 99;
    }

    .xl72 {
        mso-style-parent: styleStu;
        text-align: left;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        max-width: 300px;
        min-width: 300px;
        white-space: normal;

        position: sticky;
        left: 160px;
        background-color: #ffffff;
        z-index: 99;
    }

    .xl73 {
        mso-style-parent: styleStu;
        text-align: center;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;

        /* position: sticky; */
        /* left: 460px; */
        z-index: 0;
        background-color: #ffffff;
    }

    .xl77 {
        border-left: .5pt solid windowtext;

        position: sticky;
        z-index: 99;
        right: -1px;
        background-color: #ffffff;
    }

    /*    .sticky-table {
        overflow: auto;
        width: 100%;
    } */

    /* 教师教学质量评价（学生） end */
</style>



// WEBPACK FOOTER //
// stuEvaluate.vue?99120cae